import React from "react";
import Box from "@components/Atoms/Box";
import { useGetAllLearnosityAdaptivePracticeQuestions } from "../../hooks/query";

const LearnosityAdaptivePracticeDebugCoverage = () => {
  const { data: adaptiveQuestions } = useGetAllLearnosityAdaptivePracticeQuestions();
  const count = adaptiveQuestions?.length || 0;
  const questionCountsByTag = adaptiveQuestions?.reduce((acc, question) => {
    const tags = (question as any)?.tags || [];
    Object.keys(tags).forEach((tag) => {
      tags[tag].forEach(innerTag => {
        if (acc[tag] && acc[tag][innerTag]) {
          acc[tag][innerTag] += 1;
        } else {
          acc[tag] = {
            ...acc[tag],
            [innerTag]: 1
          }
        }
      });
    });
    return acc;
  }, {} as Record<string, Record<string, number>>);

  return <Box sx={{ height: "500px", width: "600px", padding: "20px", overflow: "scroll" }}>
    <h1>Debug Coverage</h1>
    <p>
      <strong>Adaptive Questions Count:</strong> {count}
      <details>
        <summary>Question Counts by Tag</summary>
        <p>
          {questionCountsByTag && Object.keys(questionCountsByTag).sort().map((tag, idx) => (
            <details key={idx} style={{ paddingLeft: "12px" }}>
              <summary>{tag}</summary>
              <p>
                {Object.keys(questionCountsByTag[tag]).map((innerTag, idx) => (
                  <p key={`${idx}-${innerTag}`} style={{ paddingLeft: "12px" }}>
                    <strong>{innerTag}:</strong> {questionCountsByTag[tag][innerTag]}
                  </p>
                ))}
              </p>
            </details>
          ))}
        </p>
      </details>
    </p>
    {adaptiveQuestions?.map((question, idx) =>
      <details key={question?.reference}>
        <summary>{question?.reference}</summary>
        <div style={{ paddingLeft: "12px" }}>
          {Object.keys(question).map((key) => (
            <details key={`${idx}-${key}`}>
              <summary>{key}</summary>
              <p>
                <pre><code>{JSON.stringify(question[key], null, 2)}</code></pre>
              </p>
            </details>
          ))}
        </div>
      </details>
    )}
  </Box>

}

export default LearnosityAdaptivePracticeDebugCoverage;
// This component is used to display the debug coverage information for the Learnosity Adaptive Practice tab.